<sd-form-libelle
  [labelHidden]="labelHidden"
  [labelTitle]="labelTitle"
  [required]="required"
/>

<sd-dropdown #dropdown
  [brand]="brand"
  [isBtnSmall]="isSmall"
  [type]="dropdownType"
  [isSelected]="currentValue?.length > 0"
  [isCustomDropdown]="hasAutocomplete"
  dropdownCustomClass="is-select-menu is-multiple"
  [(isOpened)]="isOpened"
  [attr.title]="placeholder"
  (isOpenedChange)="isOpenedChange.emit($event)"
  (buttonSize)="buttonSize = $event"
>
  <ng-container sd-dropdown-button>
    <div class="c__values">
      @if (placeholder) {
        <span class="is-placeholder">{{placeholder}}</span>
      }
    </div>
  </ng-container>

  @if (hasAutocomplete) {
    <sd-form autocomplete
      sd-dropdown-menu
      (formChange)="onChange($event)"
      [displayWidth]="displayWidth"
      [maxDisplayedResults]="-1"
      classField="c__input"
      [optionsAreCheckboxes]="true"
      [isSelect]="true"
      [elements]="items"
      [properties]="['libelle']"
      [minLength]="0"
    />
  }

  @if (!hasAutocomplete) {
    <sd-form checkbox-group
      #checkbox
      sd-dropdown-menu
      [brand]="brand"
      customListClass="c__option"
      [style.width.px]="buttonSize"
      (checkedChange)="onChange($event)"
      [nameField]="nameField"
      [required]="required"
      [groupLibelleTemplate]="libelleTemplate"
      [labelTitle]="labelTitle"
      [labelHidden]="true"
      [items]="items"
    >
      <ng-template #libelleTemplate let-item="item">
        <ng-container *ngTemplateOutlet="groupLibelleTemplate; context: { item: item }" />
      </ng-template>
    </sd-form>
  }
</sd-dropdown>

@if (displaySelection && selectedItems?.length > 0) {
  <ul sd-list-inline class="c__selected-items">
    @for (item of selectedItems; track item) {
      <li>
        <sd-tag [isButton]="true"
          [tagData]="{
            icon: 'icon-cross',
            iconPos: positionEnum.right,
            theme: themesEnum.default,
            text: item?.libelle
          }"
          (tagClicked)="deleteSelection(item)"
        />
      </li>
    }
  </ul>
}

<ng-content select="[sd-message]" />
